import {
  TablePagination as MuiTablePagination,
  TablePaginationProps as MuiTablePaginationProps
} from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ArrowDown from '../../../../../../icons/svg/arrow_down.svg?react';
import { TablePaginationActions } from './actions';

type Props = Pick<
  MuiTablePaginationProps,
  'count' | 'onPageChange' | 'page' | 'rowsPerPage' | 'onRowsPerPageChange'
>;
export type TablePaginationProps = Props;

export const TablePagination: FC<Props> = ({
  count,
  onPageChange,
  page,
  rowsPerPage = 10,
  onRowsPerPageChange
}) => {
  const { t } = useTranslation('template');

  return (
    <MuiTablePagination
      component="div"
      onRowsPerPageChange={onRowsPerPageChange}
      count={count}
      onPageChange={onPageChange}
      page={page}
      rowsPerPage={rowsPerPage}
      labelRowsPerPage={t('COUNT')}
      labelDisplayedRows={({ from, to }) =>
        t('PAGINATION_COUNT', {
          from,
          to,
          total: count
        })
      }
      ActionsComponent={TablePaginationActions}
      rowsPerPageOptions={[5, 10, 25, 50, 100]}
      sx={(theme) => ({
        overflow: 'hidden',
        borderBottom: '0px',
        borderRadius: '8px',

        '& .MuiInputBase-root': {
          marginLeft: '16px',
          marginRight: '24px'
        },
        '& .MuiTablePagination-select': {
          display: 'flex',
          alignItems: 'center',
          border: `1px solid ${theme.palette.grey['50']}`,
          backgroundColor: `${theme.palette.grey['50']}`,
          borderRadius: '8px',
          padding: '5px 24px 5px 8px',
          minHeight: '24px !important',
          width: '56px',
          '&:focus': {
            backgroundColor: `${theme.palette.grey['50']}`,
            borderRadius: '8px'
          },
          color: theme.palette.primary.main
        },
        '& .MuiTablePagination-selectIcon': {
          right: '10px',
          top: '6px',
          height: '24px',
          width: '24px'
        },
        '& .MuiBox-root': {
          marginLeft: '16px'
        }
      })}
      SelectProps={{
        IconComponent: ArrowDown,
        MenuProps: {
          BackdropProps: {
            invisible: true,
            style: { backgroundColor: 'transparent', opacity: '0' }
          }
        }
      }}
    />
  );
};
